import { gql } from '@apollo/client'

const UPDATE_INGREDIENT_IMAGE_DETAILS_MUTATION = gql`
  mutation updateIngredientImageDetails(
    $id: ID!
    $data: IngredientImageDetailsInput!
  ) {
    updateIngredientImageDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      imageUrl
    }
  }
`

export default UPDATE_INGREDIENT_IMAGE_DETAILS_MUTATION
